import { ControlledMultiselectField } from 'components/Form';

import type React from 'react';
import { useMemo } from 'react';
import type { UseControllerProps } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { useWorkOrderObjects } from '../hooks/useWorkOrderObjects';

interface IActKC2ObjectField extends UseControllerProps {
    label?: string;
    disabled?: boolean;
    required?: boolean;
    constructionTypeId?: number;
    hasToShowObjectsOnly?: boolean;
    isConstructionTypeDependent?: boolean;
}

export const ActKC2ObjectField: React.FC<IActKC2ObjectField> = (props) => {
    const {
        control,
        disabled,
        name,
        required,
        rules,
        constructionTypeId,
        hasToShowObjectsOnly,
        isConstructionTypeDependent,
    } = props;
    const { orderId } = useParams();

    const { workOrderObjects } = useWorkOrderObjects(Number(orderId), true);

    const items = useMemo(() => {
        let objects = isConstructionTypeDependent
            ? workOrderObjects?.filter((c) => c?.constructionType?.id === constructionTypeId)
            : workOrderObjects;

        objects = hasToShowObjectsOnly ? objects?.filter((c) => c.parentId === null) : objects;

        return objects?.map((item) => ({
            id: item.id,
            label: item.name,
        }));
    }, [constructionTypeId, hasToShowObjectsOnly, isConstructionTypeDependent, workOrderObjects]);

    return (
        <ControlledMultiselectField
            label="Объект"
            name={name}
            control={control}
            disabled={disabled}
            labelPosition="left"
            items={items}
            required={required}
            rules={rules}
        />
    );
};

ActKC2ObjectField.displayName = 'ActKC2ObjectField';
